import { listing } from '@adc/blueprint';
import { enums } from '@adc/sdk';
import { match } from 'ts-pattern';
import { images } from '../../images/exported';
const getAssetIcons = assetType => match(assetType)
    .when(assetType => assetType === enums.AssetType.BankOwned, () => ({ iconSvg: images.iconBlue, tooltipIconSvg: null }))
    .when(assetType => assetType === enums.AssetType.Foreclosure, () => ({ iconSvg: images.iconGreen, tooltipIconSvg: null }))
    .when(assetType => assetType === enums.AssetType.ShortSale, () => ({ iconSvg: images.iconPurple, tooltipIconSvg: null }))
    .when(assetType => assetType === enums.AssetType.PrivateSeller, () => ({
    iconSvg: images.iconPurple,
    tooltipIconSvg: images.smartsaleLogoIcon,
}))
    .otherwise(() => ({ iconSvg: images.iconGray, tooltipIconSvg: null }));
const getDisplayIndicator = targetListing => {
    const displayInfo = listing.utils.getDisplayIndicator(targetListing);
    const assetType = targetListing.listing_configuration?.asset_type;
    return { ...displayInfo, ...getAssetIcons(assetType) };
};
export default getDisplayIndicator;
//# sourceMappingURL=index.js.map